import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hours" }
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "items" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "backward",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backward && _ctx.backward(...args)))
      }),
      _createElementVNode("div", {
        class: "title_date-picker",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeDays && _ctx.changeDays(...args)))
      }, _toDisplayString(_ctx.filterMoment(new Date(this.innerYear, this.innerMonth, this.innerDay), "D MMM YYYY")), 1),
      _createElementVNode("div", {
        class: "next",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      })
    ]),
    (!_ctx.allowedToShowView('minutes'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "back-to-days",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openDays && _ctx.openDays(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerHours, (hour) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["hour", hour.type]),
          onClick: _withModifiers(($event: any) => (_ctx.changeHour(hour)), ["stop"])
        }, [
          _createElementVNode("div", null, _toDisplayString(hour.name), 1)
        ], 10, _hoisted_4))
      }), 256))
    ])
  ]))
}